import { /* makeStyles, Theme, */ Typography } from "@material-ui/core";
import React from "react";
import careerImage from "./Assets/career.svg";
import clockImage from "./Assets/clock.svg";
import navigationImage from "./Assets/navigation.svg";
import talentImage from "./Assets/talent.svg";
import videoImage from "./Assets/video.svg";
import Categories from "./Categories";
import CategoryData from "./CategoryData";
import ContactInformation from "./WDContactInformation";

// const useStyles = makeStyles((theme: Theme) => ({}));

const categories = [
  {
    title: "Getting Started for Manager",
    icon: navigationImage,
    subCategories: [
      {
        //https://d1xzj63c8dqlov.cloudfront.net
        title: "Video",
        icon: videoImage,
        mainLinks: [
          {
            title: "Getting Started",

            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0aea8716-a456-4de8-aa7c-386720f37071",
          },
        ],

        jobAids: [
          {
            title: "Manager FAQ's",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/ae576d0b-4143-4e1e-bd14-4b10f50abef9",
          },
          {
            title: "Annual Performance Review",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-aa56-4de8-aa7c-386720f37071",
          },
          {
            title: "Delegating Inbox",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ad56-4de8-aa7c-386720f37071",
          },
          {
            title: "Workday Mobile Setup",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ah56-4de8-aa7c-386720f37071",
          },
          {
            title: "Performance Improvement Plan",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ap56-4de8-aa7c-386720f37071",
          },
          {
            title: "Workday Change Impact",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/aa161673-adbd-4a4f-bda7-abf3fe2a5340",
          },
        ],
      },
    ],
  },

  {
    title: "PTO and Approvals",
    icon: clockImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [
          {
            title: "Approving time off",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0aea8712-a456-4de8-aa7c-386720f37071",
          },
          {
            title: "Kronos Manager Training Recording",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/71a49181-924e-4dd3-afbd-c4c956e66257",
          },
        ],
        jobAids: [
          {
            title: "Approving time off",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ab56-4de8-aa7c-386720f37071",
          },
          {
            title: "Correcting Time off",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/f61521e2-bc26-492e-95a7-368ccf5d656a",
          },
          {
            title: "Kronos Management for Nonexempt Employees",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ai56-4de8-aa7c-386720f37071",
          },
        ],
      },
    ],
  },
  {
    title: "Onboarding and Offboarding",
    icon: navigationImage,

    subCategories: [
      {
        icon: videoImage,
        mainLinks: [],
        jobAids: [
          {
            title: "Creating Job Requisition",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/5c60f002-3cf2-4dd4-afbd-22c914b8f7ec",
          },
          {
            title: "Onboarding",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/f693ebb9-4e52-401b-ab64-9b650a92cd64",
          },
          {
            title: "Termination of Direct Report",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/e20fdc1d-a5e7-414b-8d2e-6e39d05b0b39",
          },
        ],
      },
    ],
  },
  {
    title: "Job Changes",

    icon: talentImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [
          {
            title: "Compensation Change",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/513adbe8-f573-41c7-b7dd-0c1783e7dc9f",
          },
        ],
        jobAids: [
          {
            title: "Shift Change",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ar56-4de8-aa7c-386720f37071",
          },
          {
            title: "New and Renew Contractor Request Form",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/52ccecbc-6031-43e2-908e-c1de411caa16",
          },
          {
            title: "End and Extend Contractors in Workday",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/b7fb022a-ef6c-4a5d-97ce-7f3609693c44",
          },
        ],
      },
    ],
  },

  {
    title: "Performance Management",
    icon: careerImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [],
        jobAids: [
          {
            title: "Annual Performance Review",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-aa56-4de8-aa7c-386720f37071",
          },
          {
            title: "Career Development Plan",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/540f1184-b2b5-4b76-b877-723b1985c367",
          },
          {
            title: "Performance Improvement Plan",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ap56-4de8-aa7c-386720f37071",
          },
          {
            title: "Disciplinary Action for Employee",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/fdc7a6c8-51a4-49df-989e-c1075f88f6e8",
          },
        ],
      },
    ],
  },
  {
    title: "Workday Wednesday Recorded Sessions",
    icon: navigationImage,
    subCategories: [
      {
        title: "Video",
        icon: videoImage,
        mainLinks: [
          {
            title: "Workday Wednesday: Managing Employee Time",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/e11ad746-626b-4a21-8604-3406b94217f4",
          },
          {
            title: "Workday Wednesday: Recruiting, Hiring and Onboarding",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/2ffe3dff-6416-4788-aa3b-0daa849cd23d",
          },
        ],
        jobAids: [],
      },
    ],
  },
] as CategoryData[];

export default function ManagerLinks() {
  // const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h4">Quick Links for Managers</Typography>

      <p>
        Welcome to Workday for Managers! <br />
        Employees logged into Workday with the role of a manager will have additional security access, applications, and
        business processes. These differences will give managers access to information about their direct reports, such
        as ability to view employee job details, review and approve time off requests, and more. <br />
        Managers will have the ability to:
        <ul>
          <li>Approve team’s time off requests</li>
          <li>View team’s time off accruals and calendars</li>
          <li>Access paychecks</li>
          <li>View org charts</li>
          <li>Access customizable reports with graphs and analytics</li>
          <li>Coordinate and set up delegations</li>
          <li>Manage employee transactions</li>
          <li>And more!</li>
        </ul>
      </p>

      <Categories data={categories} />

      <br />
      <ContactInformation />
    </React.Fragment>
  );
}
